module.exports = __webpack_public_path__ + "img/68.f18233f6.jpg";